/*
  SF: costo de envío por comuna, antes del checkout (ficha y carro).
  - La comuna elegida se guarda en el navegador y vale para toda la tienda.
  - Carro: tarifas reales del checkout vía /cart/prepare_shipping_rates.json.
  - Ficha: tarifas reales para el producto solo, con un carro aparte de la API de Storefront
    (no toca el carro del cliente). Necesita el token público en SFEnvioConfig.storefrontToken.
*/
(function () {
  if (window.SFEnvio) return;

  var cfg = window.SFEnvioConfig || {};
  var CLAVE = 'sf_comuna';
  var oyentes = [];
  var comunasPromesa = null;
  var cache = {};

  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9ñ ]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function plata(n) {
    return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function esperar(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }

  // --- comuna elegida -------------------------------------------------------
  // `enMemoria` cubre a los navegadores que bloquean localStorage: la comuna vale al menos para esta página.
  var enMemoria = null;
  function getComuna() {
    try {
      var v = JSON.parse(localStorage.getItem(CLAVE));
      if (v && v.c && v.rp) return v;
    } catch (e) {}
    return enMemoria;
  }
  function setComuna(v) {
    enMemoria = v || null;
    try { if (v) localStorage.setItem(CLAVE, JSON.stringify(v)); else localStorage.removeItem(CLAVE); } catch (e) {}
    oyentes.slice().forEach(function (f) { try { f(v); } catch (e) {} });
  }
  function onComuna(f) { oyentes.push(f); return function () { oyentes = oyentes.filter(function (x) { return x !== f; }); }; }

  function comunas() {
    if (!comunasPromesa) {
      comunasPromesa = fetch(cfg.comunasUrl).then(function (r) { return r.json(); }).then(function (regiones) {
        var lista = [];
        regiones.forEach(function (r) {
          r[3].forEach(function (c) { lista.push({ c: c, rc: r[0], rp: r[1], rn: r[2], n: norm(c) }); });
        });
        return lista;
      }).catch(function (e) { comunasPromesa = null; throw e; });
    }
    return comunasPromesa;
  }
  function buscar(lista, texto) {
    var q = norm(texto);
    if (!q) return [];
    var empieza = [], contiene = [];
    lista.forEach(function (x) {
      var i = x.n.indexOf(q);
      if (i === 0) empieza.push(x); else if (i > 0 && x.n.charAt(i - 1) === ' ') contiene.push(x);
    });
    return empieza.concat(contiene).slice(0, 6);
  }

  // Caché corta en sessionStorage: no se vuelve a cotizar lo mismo al cambiar de página.
  var TTL = 15 * 60 * 1000;
  function leerCache(k) {
    try { var v = JSON.parse(sessionStorage.getItem('sf_cot|' + k)); if (v && Date.now() - v.t < TTL) return v.d; } catch (e) {}
    return null;
  }
  function guardarCache(k, d) { try { sessionStorage.setItem('sf_cot|' + k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }
  // Recuerda si la comuna tiene despacho el mismo día (md), para adelantar la barra de envío gratis mientras se cotiza.
  function anotarMismoDia(com, tarifas) {
    var hay = tarifas.some(function (t) { return t.mismoDia; });
    var actual = getComuna();
    if (!actual || actual.c !== com.c || actual.rc !== com.rc || actual.md === true || actual.md === hay) return;
    actual.md = hay; enMemoria = actual;
    try { localStorage.setItem(CLAVE, JSON.stringify(actual)); } catch (e) {}
  }
  // Una respuesta vacía puede ser un tropiezo pasajero del checkout (visto el 11-oct-2026: el mismo carro cotizó
  // vacío y, segundos después, con sus dos tarifas). Se reintenta antes de decir "sin despacho" y nunca se guarda.
  function conReintento(pedir, quedan) {
    return pedir().then(function (t) {
      if (t.length || quedan <= 0) return t;
      return esperar(2500).then(function () { return conReintento(pedir, quedan - 1); });
    });
  }
  function conCache(k, pedir, com) {
    if (cache[k]) return cache[k];
    var guardado = leerCache(k);
    var p = guardado && guardado.length ? Promise.resolve(guardado) : conReintento(pedir, 2).then(function (t) {
      if (t.length) guardarCache(k, t); else delete cache[k];
      return t;
    });
    p = p.then(function (t) { if (t.length) anotarMismoDia(com, t); return t; });
    cache[k] = p;
    p.catch(function () { delete cache[k]; });
    return p;
  }

  // --- tarifas --------------------------------------------------------------
  function limpiar(r) {
    var nombre = r.name || r.title || '';
    var fuente = /chilexpress/i.test((r.source || '') + ' ' + nombre) ? 'chilexpress'
      : /blue\s?express/i.test((r.source || '') + ' ' + nombre) ? 'blue'
      : /starken/i.test((r.source || '') + ' ' + nombre) ? 'starken' : 'otro';
    var precio = r.price != null ? parseFloat(r.price) : parseFloat((r.estimatedCost || {}).amount);
    return {
      nombre: nombre,
      precio: isNaN(precio) ? 0 : Math.round(precio),
      fuente: fuente,
      transportista: fuente === 'chilexpress' ? 'Chilexpress' : fuente === 'blue' ? 'Blue Express' : fuente === 'starken' ? 'Starken' : nombre,
      plazo: (r.description || '').replace(/\s+/g, ' ').trim(),
      mismoDia: fuente === 'chilexpress'
    };
  }
  // SFEnvioConfig.ocultar: transportistas que no se muestran aunque el checkout los cotice (ej. ['starken']).
  function ordenar(tarifas) {
    var ocultar = cfg.ocultar || [];
    return tarifas.map(limpiar).filter(function (t) { return ocultar.indexOf(t.fuente) === -1; }).sort(function (a, b) { return a.precio - b.precio; });
  }
  // "Starken o Blue Express": transportistas de una cotización, del más barato al más caro, sin repetir.
  function transportistas(tarifas) {
    var n = [];
    tarifas.forEach(function (t) { if (n.indexOf(t.transportista) === -1) n.push(t.transportista); });
    return n.length > 1 ? n.slice(0, -1).join(', ') + ' o ' + n[n.length - 1] : (n[0] || '');
  }
  function dirCarro(com) {
    var p = new URLSearchParams();
    p.set('shipping_address[country]', 'Chile');
    p.set('shipping_address[province]', com.rp);
    p.set('shipping_address[city]', com.c);
    p.set('shipping_address[zip]', '');
    return p;
  }

  // Carro de la sesión. `firma` identifica el contenido del carro para no volver a cotizar lo mismo.
  function cotizarCarro(com, firma) {
    var dir = dirCarro(com);
    return conCache('carro|' + com.rc + '|' + com.c + '|' + firma, function () {
      return fetch('/cart/prepare_shipping_rates.json', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: dir.toString() })
        .then(function (r) { if (!r.ok && r.status !== 202) throw new Error('prepare ' + r.status); })
        .then(function () {
          var intentos = 0;
          function sondear() {
            return fetch('/cart/async_shipping_rates.json?' + dir.toString()).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
              if (j && j.shipping_rates) return ordenar(j.shipping_rates);
              if (++intentos >= 14) throw new Error('sin respuesta');
              return esperar(900).then(sondear);
            });
          }
          return esperar(700).then(sondear);
        });
    }, com);
  }

  // Producto solo, desde la ficha. Crea un carro aparte en la API de Storefront.
  // Las tarifas de transportistas solo llegan con withCarrierRates y @defer: la respuesta viene en partes (multipart).
  function storefront(query, variables) {
    // En el dominio de vista previa (*.shopifypreview.com) la ruta relativa no llega a la tienda: ahí va la URL completa.
    var base = /\.shopifypreview\.com$/.test(location.hostname) && cfg.tiendaUrl ? cfg.tiendaUrl : '';
    return fetch(base + '/api/' + (cfg.apiVersion || '2025-01') + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.storefrontToken },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { if (!r.ok) throw new Error('storefront ' + r.status); return r.text(); })
      .then(function (texto) {
        var partes = [];
        texto.split(/\r?\n--graphql(?:--)?\r?\n?/).forEach(function (trozo) {
          var i = trozo.indexOf('{');
          if (i === -1) return;
          try { partes.push(JSON.parse(trozo.slice(i))); } catch (e) {}
        });
        if (!partes.length) throw new Error('storefront sin datos');
        partes.forEach(function (p) { if (p.errors) throw new Error('storefront'); });
        return partes;
      });
  }
  function opciones(partes) {
    var out = [];
    function grupos(g) { ((g && g.nodes) || []).forEach(function (n) { (n.deliveryOptions || []).forEach(function (o) { out.push(o); }); }); }
    partes.forEach(function (p) {
      if (p.data && p.data.cart) grupos(p.data.cart.deliveryGroups);
      (p.incremental || []).forEach(function (inc) { if (inc.data) grupos(inc.data.deliveryGroups); });
    });
    return out;
  }
  function cotizarProducto(com, variantId, cantidad) {
    if (!cfg.storefrontToken) return Promise.reject(new Error('sin token'));
    return conCache('prod|' + com.rc + '|' + com.c + '|' + variantId + '|' + (cantidad || 1), function () {
      return storefront(
        'mutation($lines:[CartLineInput!]!,$dir:MailingAddressInput!){ cartCreate(input:{lines:$lines, buyerIdentity:{countryCode:CL, deliveryAddressPreferences:[{deliveryAddress:$dir}]}}){ cart{ id } userErrors{ message } } }',
        { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: cantidad || 1 }], dir: { city: com.c, province: com.rp, country: 'CL', zip: '' } }
      ).then(function (partes) {
        var cart = partes[0].data && partes[0].data.cartCreate && partes[0].data.cartCreate.cart;
        if (!cart) throw new Error('sin carro');
        return storefront('query($id:ID!){ cart(id:$id){ id ... @defer { deliveryGroups(first:5, withCarrierRates:true){ nodes{ deliveryOptions{ title code description estimatedCost{ amount } } } } } } }', { id: cart.id });
      }).then(function (partes) { return ordenar(opciones(partes)); });
    }, com);
  }

  // --- selector de comuna (campo con sugerencias) ---------------------------
  var serie = 0;
  function selector(cont, opciones_) {
    var o = opciones_ || {};
    var id = 'sf-comuna-' + (++serie);
    cont.innerHTML =
      '<div class="sf-comuna">' +
        '<label class="sf-comuna__label" for="' + id + '">¿A qué comuna enviamos?</label>' +
        '<div class="sf-comuna__campo">' +
          '<input class="sf-comuna__input" id="' + id + '" type="text" inputmode="text" autocomplete="off" autocapitalize="words" spellcheck="false" placeholder="Escribe tu comuna" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="' + id + '-lista">' +
          '<button class="sf-comuna__cerrar" type="button" aria-label="Cancelar">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6l-12 12"/><path d="M6 6l12 12"/></svg>' +
          '</button>' +
        '</div>' +
        '<ul class="sf-comuna__lista" id="' + id + '-lista" role="listbox" hidden></ul>' +
        '<p class="sf-comuna__ayuda" aria-live="polite"></p>' +
      '</div>';
    var input = cont.querySelector('.sf-comuna__input'), lista = cont.querySelector('.sf-comuna__lista'), ayuda = cont.querySelector('.sf-comuna__ayuda');
    var resultados = [], activo = -1, todas = null;

    comunas().then(function (l) { todas = l; if (input.value) pintar(); }).catch(function () { ayuda.textContent = 'No pudimos cargar las comunas. Revisa tu conexión e intenta de nuevo.'; });

    function pintar() {
      if (!todas) return;
      resultados = buscar(todas, input.value);
      activo = resultados.length ? 0 : -1;
      lista.innerHTML = resultados.map(function (x, i) {
        return '<li class="sf-comuna__op" role="option" id="' + id + '-op' + i + '" data-i="' + i + '" aria-selected="' + (i === activo) + '"><span>' + x.c + '</span><small>' + x.rn + '</small></li>';
      }).join('');
      lista.hidden = !resultados.length;
      input.setAttribute('aria-expanded', String(!!resultados.length));
      if (activo >= 0) input.setAttribute('aria-activedescendant', id + '-op' + activo); else input.removeAttribute('aria-activedescendant');
      ayuda.textContent = norm(input.value).length >= 3 && !resultados.length ? 'No encontramos esa comuna. Prueba con las primeras letras.' : '';
    }
    function marcar(i) {
      if (!resultados.length) return;
      activo = (i + resultados.length) % resultados.length;
      Array.prototype.forEach.call(lista.children, function (li, n) { li.setAttribute('aria-selected', String(n === activo)); });
      input.setAttribute('aria-activedescendant', id + '-op' + activo);
    }
    function elegir(i) {
      var x = resultados[i];
      if (!x) return;
      var v = { c: x.c, rc: x.rc, rp: x.rp, rn: x.rn };
      setComuna(v);
      if (o.alElegir) o.alElegir(v);
    }
    input.addEventListener('input', pintar);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); marcar(activo + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); marcar(activo - 1); }
      else if (e.key === 'Enter') { e.preventDefault(); if (activo >= 0) elegir(activo); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (o.alCancelar) o.alCancelar(); }
    });
    // pointerdown: elige antes de que el campo pierda el foco
    lista.addEventListener('pointerdown', function (e) {
      var li = e.target.closest('.sf-comuna__op');
      if (li) { e.preventDefault(); elegir(parseInt(li.getAttribute('data-i'), 10)); }
    });
    cont.querySelector('.sf-comuna__cerrar').addEventListener('click', function () { if (o.alCancelar) o.alCancelar(); });
    if (o.foco !== false) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
    return input;
  }

  var api = window.SFEnvio = {
    ultimo: null,
    getComuna: getComuna, setComuna: setComuna, onComuna: onComuna,
    cotizarCarro: cotizarCarro, cotizarProducto: cotizarProducto,
    selector: selector, plata: plata, transportistas: transportistas, tieneToken: function () { return !!cfg.storefrontToken; }
  };

  // --- carro: fila "Envío" en el pie del carro --------------------------------
  // #cart-footer se reemplaza entero en cada cambio del carro: el elemento se vuelve a crear solo.
  // Cotiza recién cuando se ve (el carro lateral existe oculto en todas las páginas) y avisa su estado con el
  // evento `sf:envio` {estado: vacio | sin-comuna | cargando | ok | error, comuna, tarifas, subtotal}.
  class EnvioCarro extends HTMLElement {
    connectedCallback() {
      this.subtotal = parseInt(this.getAttribute('data-total'), 10) / 100;
      // v1.26.0: precio sin descuentos (para el tachado del total) y si hay un producto de gran volumen
      this.original = parseInt(this.getAttribute('data-original') || this.getAttribute('data-total'), 10) / 100;
      this.grande = this.hasAttribute('data-grande');
      this.firma = this.getAttribute('data-firma');
      this.cantidad = parseInt(this.getAttribute('data-count') || '1', 10);
      this.turno = 0;
      this.visto = false;
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-accion]');
        if (!b) return;
        e.preventDefault();
        if (b.getAttribute('data-accion') === 'elegir') this.editar();
        if (b.getAttribute('data-accion') === 'reintentar') this.cotizar();
      });
      if (!this.cantidad) { this.innerHTML = ''; this.avisar('vacio'); return; }
      this.soltar = onComuna(() => this.cotizar());
      this.cotizar();
      if ('IntersectionObserver' in window) {
        this.ojo = new IntersectionObserver((entradas) => {
          if (!entradas.some((x) => x.isIntersecting)) return;
          this.ojo.disconnect();
          this.visto = true;
          this.cotizar();
        });
        this.ojo.observe(this);
      } else { this.visto = true; this.cotizar(); }
    }
    disconnectedCallback() { if (this.soltar) this.soltar(); if (this.ojo) this.ojo.disconnect(); }
    avisar(estado, comuna, tarifas) {
      api.ultimo = { estado: estado, comuna: comuna || null, tarifas: tarifas || [], subtotal: this.subtotal };
      document.dispatchEvent(new CustomEvent('sf:envio', { detail: api.ultimo }));
    }
    fila(izq, der, nota) {
      this.innerHTML = '<div class="sf-envio__fila"><span class="sf-envio__txt">' + izq + '</span>' + (der ? '<span class="sf-envio__valor">' + der + '</span>' : '') + '</div>' + (nota ? '<p class="sf-envio__nota">' + nota + '</p>' : '');
    }
    // v1.26.0: total con el precio sin descuentos tachado y "Ahorras $X" (descuentos + envío gratis), como la glosa de MeLi.
    // envio: costo del envío o null si aún no se sabe (sin comuna o cotizando); envioTachado: lo que costaría sin el envío gratis.
    total(envio, envioTachado) {
      const conEnvio = envio !== null && envio !== undefined;
      const pagar = this.subtotal + (conEnvio ? envio : 0);
      const lista = this.original + (conEnvio ? envio + (envioTachado || 0) : 0);
      const ahorro = Math.max(0, Math.round(lista - pagar));
      const t = document.createElement('div');
      t.className = 'sf-envio__total';
      t.innerHTML = '<span class="sf-envio__k">Total</span><span class="sf-envio__tot">' + (ahorro > 0 ? '<s>' + plata(lista) + '</s> ' : '') + '<strong>' + plata(pagar) + '</strong></span>';
      this.appendChild(t);
      if (ahorro > 0) {
        const a = document.createElement('p');
        a.className = 'sf-envio__ahorro';
        a.textContent = 'Ahorras ' + plata(ahorro);
        this.appendChild(a);
      }
    }
    // v1.26.0: promesa de entrega bajo el botón "Ir a pagar" (mismo #cart-footer)
    promesa(html) {
      const p = (this.closest('#cart-footer') || document).querySelector('[data-sf-promesa]');
      if (p) p.innerHTML = html || '';
    }
    promesaGeneral() {
      if (this.grande) return 'Producto de gran volumen: coordinamos la entrega contigo.';
      const c = typeof window.SFCuando === 'function' ? window.SFCuando() : 'mañana';
      return '<strong>Llega ' + c + ' en la RM</strong>' + (c === 'hoy' ? ' si compras antes de las 12:00' : '');
    }
    editar() {
      this.turno++;
      this.innerHTML = '<div class="sf-envio__editor"></div>';
      selector(this.firstChild, { alCancelar: () => this.cotizar() });
    }
    cotizar() {
      const com = getComuna(), turno = ++this.turno;
      if (!com) {
        this.fila('Envío', '<button class="sf-envio__link" type="button" data-accion="elegir">Calcular con mi comuna</button>');
        this.total(null);
        this.promesa(this.promesaGeneral());
        this.avisar('sin-comuna');
        return;
      }
      const destino = 'Envío a <button class="sf-envio__link" type="button" data-accion="elegir" aria-label="Cambiar comuna, ahora ' + com.c + '">' + com.c + '</button>';
      this.fila(destino, '<span class="sf-envio__carga" role="status">Calculando…</span>');
      this.total(null);
      this.avisar('cargando', com);
      if (!this.visto) return;
      cotizarCarro(com, this.firma).then((tarifas) => {
        if (turno !== this.turno) return;
        this.avisar('ok', getComuna() || com, tarifas);
        if (!tarifas.length) {
          this.fila(destino, '', 'No encontramos despacho a esta comuna para tu carro. Escríbenos por WhatsApp y lo coordinamos.');
          this.total(null);
          this.promesa('');
          return;
        }
        const t = tarifas[0];
        // envío gratis del mismo día: se muestra tachado lo que cuesta bajo el umbral (cfg.envioMismoDia)
        const tachado = t.precio === 0 && t.mismoDia ? (cfg.envioMismoDia || 2990) : 0;
        // el mismo día es una sola tarifa: sin "desde" aunque el checkout ofrezca además otro transportista
        const valor = t.precio === 0
          ? (tachado ? '<s class="sf-envio__tach">' + plata(tachado) + '</s> ' : '') + '<span class="sf-envio__gratis">Gratis</span>'
          : (tarifas.length > 1 && !t.mismoDia ? 'desde ' : '') + plata(t.precio);
        const promesa = this.grande ? 'Producto de gran volumen: coordinamos la entrega contigo.'
          : t.mismoDia
          ? (function () { const n = t.nombre.replace(/\s*·\s*Chilexpress\s*$/i, '').replace(/\s+gratis/i, ''); return '<strong>' + n + '</strong>' + (/\bhoy\b/i.test(n) ? ' si compras antes de las 12:00' : ''); })()
          : tarifas.length > 1 ? transportistas(tarifas) + ', eliges al pagar'
          : t.transportista + (t.plazo ? ' · ' + t.plazo.charAt(0).toLowerCase() + t.plazo.slice(1) : '');
        this.fila(destino, valor);
        this.total(t.precio, tachado);
        this.promesa(promesa);
      }).catch(() => {
        if (turno !== this.turno) return;
        this.avisar('error', com);
        this.fila(destino, '<button class="sf-envio__link" type="button" data-accion="reintentar">Reintentar</button>', 'No pudimos calcular el envío ahora. También lo verás antes de pagar.');
        this.total(null);
        this.promesa('');
      });
    }
  }

  // --- carro: barra de avance al envío gratis ---------------------------------
  // Solo promete donde hay envío gratis: comunas con despacho el mismo día (lo dice la cotización del carro).
  const CAMION = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"/></svg>';
  const VISTO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/><path d="M9 12l2 2l4 -4"/></svg>';
  // Qué muestra la barra para un estado del envío: null (nada) o {logrado, falta, lugar, general}.
  function avance(d) {
    const umbral = cfg.umbralGratis || 19990;
    if (!d || d.estado === 'vacio') return null;
    const falta = Math.max(0, umbral - d.subtotal);
    // v1.26.0: la barra solo se muestra mientras falta monto; logrado el envío gratis lo dice la fila de envío del pie.
    if (d.estado === 'sin-comuna') return falta === 0 ? null : { logrado: false, falta: falta, lugar: 'en la RM', general: true };
    if (d.estado === 'ok') {
      const sdd = d.tarifas.find((t) => t.mismoDia);
      if (!sdd || sdd.precio === 0 || falta === 0) return null;
      return { logrado: sdd.precio === 0, falta: falta, lugar: 'a ' + d.comuna.c, general: false };
    }
    if (d.estado === 'cargando' && d.comuna && d.comuna.md === true && falta > 0) return { logrado: false, falta: falta, lugar: 'a ' + d.comuna.c, general: false };
    return undefined; // cargando o error: se deja lo que había
  }
  class EnvioAvance extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.oir = (e) => this.pintar(e.detail);
      document.addEventListener('sf:envio', this.oir);
      this.addEventListener('click', (e) => {
        if (!e.target.closest('[data-accion="comuna"]')) return;
        e.preventDefault();
        const fila = (this.closest('drawer-cart, .main-cart') || document).querySelector('sf-envio-carro');
        if (!fila) return;
        fila.editar();
        fila.scrollIntoView({ block: 'center' });
      });
      if (api.ultimo) this.pintar(api.ultimo);
    }
    disconnectedCallback() { document.removeEventListener('sf:envio', this.oir); }
    pintar(d) {
      const a = avance(d);
      if (a === undefined) return;
      if (!a) { this.hidden = true; this.clave = ''; return; }
      const umbral = cfg.umbralGratis || 19990;
      const clave = [a.logrado, a.falta, a.lugar].join('|');
      if (clave === this.clave) return;
      this.clave = clave;
      const texto = a.logrado
        ? (a.general ? 'Tu compra alcanza el <strong>envío gratis</strong> ' + a.lugar : 'Tienes <strong>envío gratis</strong> ' + a.lugar)
        : 'Te faltan <strong>' + plata(a.falta) + '</strong> para el envío gratis ' + a.lugar;
      const nota = a.general
        ? 'En comunas con cobertura, pidiendo antes de las 12:00. <button class="sf-envio__link" type="button" data-accion="comuna">Ver mi comuna</button>'
        : 'Pidiendo antes de las 12:00.';
      if (!this.firstChild) {
        this.innerHTML = '<div class="sf-avance"><p class="sf-avance__txt"><span class="sf-avance__ic"></span><span class="sf-avance__msj" aria-live="polite"></span></p>' +
          '<div class="sf-avance__pista" role="progressbar" aria-label="Avance hacia el envío gratis" aria-valuemin="0" aria-valuemax="' + umbral + '"><span></span></div>' +
          '<p class="sf-avance__nota"></p></div>';
      }
      const caja = this.firstChild;
      caja.classList.toggle('sf-avance--logrado', a.logrado);
      caja.querySelector('.sf-avance__ic').innerHTML = a.logrado ? VISTO : CAMION;
      caja.querySelector('.sf-avance__msj').innerHTML = texto;
      caja.querySelector('.sf-avance__nota').innerHTML = nota;
      const pista = caja.querySelector('.sf-avance__pista');
      pista.setAttribute('aria-valuenow', String(Math.min(umbral, Math.round(umbral - a.falta))));
      pista.firstChild.style.transform = 'scaleX(' + (a.logrado ? 1 : Math.max(0.04, (umbral - a.falta) / umbral)).toFixed(3) + ')';
      this.hidden = false;
    }
  }

  // --- carro: "Completa tu pedido" ---------------------------------------------
  // Hasta tres productos de la colección curada (cfg.complementosUrl), sin agotados ni lo que ya está en el carro.
  // Si falta para el envío gratis, primero va el más barato que lo alcanza.
  let coleccion = null;
  function complementos() {
    if (!coleccion) {
      coleccion = fetch(cfg.complementosUrl).then((r) => r.json()).then((j) => (j.products || []).map((p) => {
        const v = (p.variants || []).find((x) => x.available);
        if (!v) return null;
        const img = p.images && p.images[0] ? p.images[0].src : '';
        return {
          id: String(p.id), vid: v.id, titulo: p.title, url: '/products/' + p.handle, tipo: p.product_type,
          precio: Math.round(parseFloat(v.price)), antes: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price)) : 0,
          img: img ? img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=144' : ''
        };
      }).filter(Boolean)).catch((e) => { coleccion = null; throw e; });
    }
    return coleccion;
  }
  function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  class Complementos extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.enCarro = (this.getAttribute('data-en-carro') || '').split(',').filter(Boolean);
      if (!this.enCarro.length || !cfg.complementosUrl) return;
      this.oir = () => this.pintar();
      document.addEventListener('sf:envio', this.oir);
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-agregar]');
        if (b) { e.preventDefault(); this.agregar(b); }
      });
      const cargar = () => complementos().then((l) => { this.lista = l; this.pintar(); }).catch(() => {});
      if ('IntersectionObserver' in window) {
        this.ojo = new IntersectionObserver((entradas) => { if (entradas.some((x) => x.isIntersecting)) { this.ojo.disconnect(); cargar(); } }, { rootMargin: '200px' });
        this.hidden = false; // tiene que ocupar lugar para que el observador lo vea
        this.ojo.observe(this);
      } else cargar();
    }
    disconnectedCallback() { if (this.oir) document.removeEventListener('sf:envio', this.oir); if (this.ojo) this.ojo.disconnect(); }
    elegir() {
      const libres = this.lista.filter((p) => this.enCarro.indexOf(p.id) === -1);
      const a = avance(api.ultimo);
      const falta = a && !a.logrado ? a.falta : 0;
      const elegidos = [];
      if (falta > 0) {
        const alcanza = libres.filter((p) => p.precio >= falta).sort((x, y) => x.precio - y.precio)[0];
        if (alcanza) elegidos.push(Object.assign({ alcanza: true }, alcanza));
      }
      // un producto por tipo; si no alcanza a juntar tres, se completa con lo que haya
      [true, false].forEach((unoPorTipo) => {
        libres.forEach((p) => {
          if (elegidos.length >= 3 || elegidos.some((e) => e.id === p.id)) return;
          if (unoPorTipo && elegidos.some((e) => e.tipo === p.tipo)) return;
          elegidos.push(p);
        });
      });
      return elegidos;
    }
    pintar() {
      if (!this.lista) return;
      const elegidos = this.elegir();
      if (!elegidos.length) { this.hidden = true; this.innerHTML = ''; this.clave = ''; return; }
      const clave = elegidos.map((p) => p.id + (p.alcanza ? '*' : '')).join(',');
      if (clave === this.clave) return;
      this.clave = clave;
      // Tarjeta igual a la de "Lleva la experiencia completa" de la ficha; los íconos son los del tema.
      const ICONO = '<svg role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag"><path d="M6.7 7c-1 0-1.8.7-2 1.7L3 20c0 1.1 2 2 9 2s9-.9 9-2L19.3 8.7c-.2-1-1-1.7-2-1.7H6.7z"></path><path d="M8 7c0-2.2.5-5 4-5s4 2.8 4 5"></path></svg>' +
        '<svg role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
      this.innerHTML = '<p class="sf-comp__titulo">Completa tu pedido</p><ul class="sf-comp__lista">' + elegidos.map((p) =>
        '<li class="sf-comp__item">' +
          '<a class="sf-comp__img" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" width="72" height="72" loading="lazy" alt="">' : '') + '</a>' +
          '<div class="sf-comp__txt"><a class="sf-comp__nombre" href="' + p.url + '">' + esc(p.titulo) + '</a>' +
            '<span class="sf-comp__precio">' + (p.antes > p.precio ? '<s>' + plata(p.antes) + '</s>' : '') + plata(p.precio) + '</span>' +
            (p.alcanza ? '<span class="sf-comp__gratis">Alcanzas el envío gratis</span>' : '') +
            '<span class="sf-comp__error" role="alert" hidden>No se pudo agregar. Intenta de nuevo.</span></div>' +
          '<button class="sf-comp__btn" type="button" data-agregar="' + p.vid + '" aria-label="Agregar ' + esc(p.titulo) + ' al carro">' + ICONO + '</button>' +
        '</li>').join('') + '</ul>';
      this.hidden = false;
    }
    agregar(b) {
      if (b.disabled) return;
      const error = b.closest('.sf-comp__item').querySelector('.sf-comp__error');
      b.disabled = true; error.hidden = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(b.getAttribute('data-agregar'), 10), quantity: 1 }) })
        .then((r) => { if (!r.ok) throw new Error('add ' + r.status); })
        // el tema vuelve a pintar el carro (y este bloque) al recibir el evento
        .then(() => document.dispatchEvent(new CustomEvent('ajaxProduct:added')))
        .catch(() => { b.disabled = false; error.hidden = false; });
    }
  }

  if (window.customElements) {
    [['sf-envio-carro', EnvioCarro], ['sf-envio-avance', EnvioAvance], ['sf-complementos', Complementos]].forEach((par) => {
      if (!customElements.get(par[0])) customElements.define(par[0], par[1]);
    });
  }
})();
